<template>
    <div class="nevs-content">
        <NevsCard>
            <NevsTextField style="float: left;" :label="$LANG.Get('labels.filter') + ':'" :width="'300px'"
                           v-model="plansData.filters.person"></NevsTextField>
            <NevsSelect style="float: left; margin-left: 15px;" :width="'220px'" :nullable="true"
                        :label="$LANG.Get('fields.status') + ':'"
                        v-model="plansData.filters.status" :options="statusOptions"></NevsSelect>
            <span style="float: right;"><NevsButton class="primary" @click="addPlan"><i class="fa-solid fa-plus"></i>
                {{ $LANG.Get('buttons.addPaymentPlan') }}</NevsButton></span>
            <div style="clear: both;"></div>

            <NevsTinyGrid :columns="gridColumns" :records="plansData.records" :actions="gridActions"
                          @action="gridAction">
                <template #cell-status="{ record }">
                    <span :class="'payment-plan-status payment-plan-status-' + record.status">
                        {{ $LANG.Get('paymentPlanStatuses.' + record.status) }}
                    </span>
                    <span v-if="record.has_error" class="payment-plan-warning"
                          :title="$LANG.Get('labels.paymentPlanHasError')"><i class="fa-solid fa-triangle-exclamation"></i></span>
                </template>
            </NevsTinyGrid>
        </NevsCard>
    </div>
</template>

<script>

import NevsCard from "@/components/nevs/NevsCard.vue";
import NevsButton from "@/components/nevs/NevsButton.vue";
import NevsTextField from "@/components/nevs/NevsTextField.vue";
import NevsSelect from "@/components/nevs/NevsSelect.vue";
import NevsTinyGrid from "@/components/nevs/NevsTinyGrid.vue";

export default {
    name: "ModulePaymentPlans",
    components: {NevsTinyGrid, NevsSelect, NevsTextField, NevsButton, NevsCard},
    data() {
        return {
            plansData: {
                filters: {
                    person: '',
                    status: null
                },
                records: [],
                filterTimer: null
            }
        }
    },
    computed: {
        statusOptions() {
            return ['draft', 'sent', 'active', 'completed', 'cancelled'].map((status) => {
                return {value: status, label: this.$LANG.Get('paymentPlanStatuses.' + status)};
            });
        },
        gridColumns() {
            return [
                {key: 'person_name', label: this.$LANG.Get('fields.person')},
                {key: 'status', label: this.$LANG.Get('fields.status')},
                {key: 'progress_display', label: this.$LANG.Get('fields.paidInstalments'), align: 'right'},
                {key: 'monthly_amount_display', label: this.$LANG.Get('fields.monthlyInstalment'), align: 'right'},
                {key: 'total_amount_display', label: this.$LANG.Get('fields.totalAmount'), align: 'right'},
                {key: 'start_date_display', label: this.$LANG.Get('fields.startDate'), align: 'right'}
            ];
        },
        gridActions() {
            return [
                {name: 'edit', icon: 'fa-solid fa-pen', tooltip: this.$LANG.Get('tooltips.edit')}
            ];
        }
    },
    watch: {
        'plansData.filters.person': {
            handler() {
                if (this.plansData.filterTimer !== null) clearTimeout(this.plansData.filterTimer);
                let vm = this;
                this.plansData.filterTimer = setTimeout(function () {
                    vm.reloadPlans();
                }, 500);
            },
            deep: true
        },
        'plansData.filters.status': {
            handler() {
                this.reloadPlans();
            }
        }
    },
    methods: {
        gridAction(name, plan) {
            if (name === 'edit') this.editPlan(plan);
        },
        editPlan(plan) {
            this.$router.push('/payment-plans/' + plan.id);
        },
        addPlan() {
            this.$router.push('/payment-plans/0');
        },
        reloadPlans() {
            let vm = this;
            let request = {
                sort: {field: 'id', descending: true},
                filters: this.plansData.filters,
                currentPage: 1,
                rowsPerPage: 0
            };
            this.$API.APICall('get', 'payment-plans', request, (data, success) => {
                if (success) {
                    vm.plansData.records = data.records;
                } else {
                    vm.$HELPERS.HandleServerError(vm, data);
                }
            });
        }
    },
    mounted() {
        this.$store.commit('selectMenu', 'finance');
        this.$store.commit('selectSubMenu', 'paymentPlans');
        this.$store.commit('setBreadcrumbs', [
            {label: this.$LANG.Get('modules.finance'), link: null},
            {label: this.$LANG.Get('modules.paymentPlans'), link: null}
        ]);
        this.reloadPlans();
    }
}
</script>

<style scoped lang="scss">
.payment-plan-status {
    display: inline-block;
    padding: 2px 8px;
    border-radius: 10px;
    font-size: 0.85em;
    background: #eeeeee;
    color: #555555;
}

.payment-plan-status-active {
    background: #e2f0e2;
    color: #2c6e2c;
}

.payment-plan-status-completed {
    background: #e2eaf5;
    color: #2f5590;
}

.payment-plan-status-cancelled {
    background: #f3e2e2;
    color: #8a3232;
}

.payment-plan-warning {
    margin-left: 6px;
    color: #c07a00;
}
</style>
